<template>  
    <section class="main_left_sidesec" v-if="isIKF">
		<div class="top_logosec">
			<router-link data-toggle="tooltip" title="Dashboard" :to="'/subscriptions'">
				<img src="../../../../static/prism_admin/images/leftbar_logo.png" alt="#" class="logo_sec" />
			</router-link>
		</div>
		<div class="prism_menusec">
			<ul class="nav navbar-nav">
				<li class="dropdown payout">
					<router-link title="subscription" :to="'/subscriptions'" style="padding: 0;line-height: 15px;">
						<trending-down-icon size="1.5x" class="custom-class"></trending-down-icon>  Subscription List
					</router-link>
				</li>
			</ul>
		</div>
	</section>
	<section class="main_left_sidesec" v-else>
		<div class="top_logosec" v-if="get_user.roles.indexOf('SSU') != -1">
			<img src="../../../../static/prism_admin/images/leftbar_logo.png" alt="#" class="logo_sec" />
		</div>
		<div class="top_logosec" v-else>
			<router-link data-toggle="tooltip" title="Dashboard" :to="'/Users/dashboard'">
				<img src="../../../../static/prism_admin/images/leftbar_logo.png" alt="#" class="logo_sec" />
			</router-link>
		</div>

		<div class="prism_menusec" v-if="get_user.roles.indexOf('SSU') != -1">
			<ul class="nav navbar-nav">
				<li class="dropdown"  >
					<router-link :to="'/squadiq-user-list'" data-toggle="tooltip" title="Squadiq Users">
					 	<list-icon size="1.5x" class="custom-class"></list-icon>
					</router-link>
				</li>
			</ul>
		</div>
		<div class="prism_menusec" v-else>
			<ul class="nav navbar-nav">
				<!-- <li class="dropdown active">
					<router-link title="Dashboard" :to="'/Users/dashboard'">
						<layout-icon size="1.5x" class="custom-class"></layout-icon>
					</router-link>
				</li> -->
				<li class="dropdown"  >
					<!-- v-if="get_user.roles.indexOf('RP') != -1" -->
					<router-link to="/reports" data-toggle="tooltip" title="Reports">
					 	<bar-chart-icon size="1.5x" class="custom-class"></bar-chart-icon>
					</router-link>
				</li>
				<li class="dropdown">
					<router-link data-toggle="tooltip" title="Support" :to="'/Tickets/support'">
						<message-square-icon size="1.5x" class="custom-class"></message-square-icon>
					</router-link>
				</li>
				<li class="dropdown" v-if="get_user.roles.indexOf('SL') != -1 || get_user.roles.indexOf('BO') != -1 || get_user.roles.indexOf('DP') != -1 || get_user.roles.indexOf('CS') != -1 || get_user.roles.indexOf('SIQ') != -1">
					<router-link data-toggle="tooltip" title="Users" to="">
						<user-icon size="1.5x" class="custom-class"></user-icon>
					</router-link>
					<ul class="dropdown-menu">
						<li class="dropdown pendinguser" v-if="get_user.roles.indexOf('BO') != -1" @click="clear_local_user_filter()">
							<router-link title="Pending Registerations" :to="'/user-listing'">
								<users-icon size="1.5x" class="custom-class"></users-icon>
							</router-link>
						</li>

						<li class="dropdown panattemptuser" @click="clear_local_user_filter()" v-if="get_user.roles.indexOf('USER_PAN_ATTEMPT') != -1" >
							<router-link title="USER-REGISTER-PAN-ATTEMPT-LIST" :to="'/pan-list'">
								<users-icon size="1.5x" class="custom-class"></users-icon>
							</router-link>
						</li>
						<li class="dropdown completeuser" v-if="get_user.roles.indexOf('BO') != -1" @click="clear_local_user_filter()">
							<router-link title="Complete Registerations" :to="'/complete-registeration'">
								<user-check-icon size="1.5x" class="custom-class"></user-check-icon>
							</router-link>
						</li>
						<li class="dropdown categorisationuser" v-if="get_user.roles.indexOf('BO') != -1 || get_user.roles.indexOf('CS') != -1" @click="clear_local_user_filter()">
							<router-link title="Categorisation list" :to="'/categorisation-list'">
								<list-icon size="1.5x" class="custom-class"></list-icon>
							</router-link>
						</li>
						<li class="dropdown dematPendinguser" v-if="get_user.roles.indexOf('DP') != -1" @click="clear_local_user_filter()">
							<router-link title="Demat Pending" :to="'/demat-pending-list'">
								<list-icon size="1.5x" class="custom-class"></list-icon>
							</router-link>
						</li>
						<li class="dropdown squadiqUser" v-if="get_user.roles.indexOf('SIQ') != -1" @click="clear_local_user_filter()">
							<router-link title="Squadiq Users" :to="'/squadiq-user-list'">
								<list-icon size="1.5x" class="custom-class"></list-icon>
							</router-link>
						</li>
						<li class="dropdown valueLeafUser"  @click="clear_local_user_filter()" v-if="get_user.roles.indexOf('SVL') != -1">
							<router-link title="Squadiq Users" :to="'/source-user-listing'">
								<list-icon size="1.5x" class="custom-class"></list-icon>
							</router-link>
						</li>
						<li class="dropdown leadRegisteration"  @click="clear_local_user_filter()" v-if="get_user.roles.indexOf('INITIAL_LEAD') != -1">
							<router-link
								title="Lead Registerations"
								:to="{
									path: '/lead-registeration',
									query: {
									startDate: '2025-06-23',
									endDate: '2025-07-23',
									minDate: '2025-06-24'
									}
								}"
							>
								<file-text-icon size="1.5x" class="custom-class"></file-text-icon>
							</router-link>
						</li>
						
					</ul>
				</li> 
				<li class="dropdown"  v-if="get_user.roles.indexOf('CVl_KRA_PANCARD') != -1">
					<router-link data-toggle="tooltip" title="cvl kra" to="">
						<file-text-icon size="1.5x" class="custom-class"></file-text-icon> 
					</router-link>
					<ul class="dropdown-menu">
						<li class="dropdown list" >
							<router-link title="list" :to="'/kyc-list'" >
								<arrow-right-circle-icon size="1.5x" class="custom-class"></arrow-right-circle-icon> Listing
							</router-link>
						</li>
						<li class="dropdown upload" >
							<router-link title="upload" :to="'/kyc-upload'">
								<arrow-left-circle-icon size="1.5x" class="custom-class"></arrow-left-circle-icon> Upload
							</router-link>
						</li>
					</ul>
				</li> 
				<li class="dropdown"  v-if="get_user.roles.indexOf('AC') != -1 || get_user.roles.indexOf('CS') != -1 || get_user.roles.indexOf('PAYMENT_SHEET') != -1">
					<router-link data-toggle="tooltip" title="Funds" to="">
						<credit-card-icon size="1.5x" class="custom-class"></credit-card-icon>
					</router-link>
					<ul class="dropdown-menu">
						<li class="dropdown payin" >
							<router-link title="payin" :to="'/payin'" >
								<arrow-right-circle-icon size="1.5x" class="custom-class"></arrow-right-circle-icon> Payin
							</router-link>
						</li>
						<li class="dropdown payout" >
							<router-link title="payout" :to="'/payout'">
								<arrow-left-circle-icon size="1.5x" class="custom-class"></arrow-left-circle-icon> Payout
							</router-link>
						</li>
						<li class="dropdown payout"  v-if="get_user.roles.indexOf('AC') != -1">
							<router-link title="payout" :to="'/reject-payout'">
								<arrow-left-circle-icon size="1.5x" class="custom-class"></arrow-left-circle-icon> Reject Payout
							</router-link>
						</li>
						<li class="dropdown payout"  v-if="get_user.roles.indexOf('PAYMENT_SHEET') != -1">
							<router-link title="payout" :to="'/payment-sheet'">
								<arrow-left-circle-icon size="1.5x" class="custom-class"></arrow-left-circle-icon> Payment Sheet
							</router-link>
						</li>
					</ul>
				</li> 
				<!-- <li class="dropdown useraccess">
					<router-link title="User Access" :to="'/client-access'">
						<users-icon size="1.5x" class="custom-class"></users-icon>
					</router-link>
				</li> -->
				<li class="dropdown"  v-if="get_user.roles.indexOf('AC') != -1 || get_user.roles.indexOf('IT') != -1 || get_user.roles.indexOf('A') != -1">
					<router-link data-toggle="tooltip" title="List" to="">
						<list-icon size="1.5x" class="custom-class"></list-icon>
					</router-link>
					<ul class="dropdown-menu">
						<li class="dropdown payin" v-if="get_user.roles.indexOf('AC') != -1">
							<router-link title="payin" :to="'/rising-list'" >
								<file-icon size="1.5x" class="custom-class"></file-icon> Rising List
							</router-link>
						</li>
						<li class="dropdown" v-if="get_user.roles.indexOf('A') != -1">
							<router-link data-toggle="tooltip" title="Rising-Clients-File-Upload" :to="'/upload-file'">
								<message-square-icon size="1.5x" class="custom-class"></message-square-icon> Rising Clients File Upload
							</router-link>
						</li>
						<li class="dropdown payout"  v-if="get_user.roles.indexOf('IT') != -1">
							<router-link title="payout" :to="'/stagging-list'">
								<trending-down-icon size="1.5x" class="custom-class"></trending-down-icon>  Stagging List
							</router-link>
						</li>
						<li class="dropdown payout"  v-if="get_user.roles.indexOf('IT') != -1">
							<router-link title="payout" :to="'/pan-info'">
								<file-icon size="1.5x" class="custom-class"></file-icon>   PAN Info
							</router-link>
						</li>
						<li class="dropdown payout"  v-if="get_user.roles.indexOf('BO') != -1 || get_user.roles.indexOf('ENTER_DATA_KORP_OR_CVL_KRA') != -1">
							<router-link title="payout" :to="'/cvl-status'">
								<file-icon size="1.5x" class="custom-class"></file-icon>   CVL Status
							</router-link>
						</li>
						<li class="dropdown payout"  v-if="get_user.roles.indexOf('BO') != -1 || get_user.roles.indexOf('ENTER_DATA_KORP_OR_CVL_KRA') != -1">
							<router-link title="payout" :to="'/cvl-response-status'">
								<file-icon size="1.5x" class="custom-class"></file-icon>   CVL Response Status
							</router-link>
						</li>
						<li class="dropdown" v-if="get_user.roles.indexOf('BO') != -1">
							<router-link data-toggle="tooltip" title="cvl-kra-File-Upload" :to="'/upload-client-code'">
								<message-square-icon size="1.5x" class="custom-class"></message-square-icon> CVL KRA File Upload
							</router-link>
						</li>
					</ul>
				</li> 
				<li class="dropdown payout"  v-if="get_user.roles.indexOf('IT') != -1">
					<router-link title="subscription" :to="'/subscriptions'">
						<trending-down-icon size="1.5x" class="custom-class"></trending-down-icon>  Subscription List
					</router-link>
				</li>
				
				<li class="dropdown">
					<router-link data-toggle="tooltip" title="Search User" :to="'/search-user'">
						<search-icon size="1.5x"></search-icon>
					</router-link>
				</li>

				

				<li class="dropdown"  v-if="get_user.roles.indexOf('A') != -1">
					<router-link data-toggle="tooltip" title="Nominee-Data" :to="'/nominee-list'">
						<file-text-icon size="1.5x" class="custom-class"></file-text-icon> 
					</router-link>
				</li>

				<li class="dropdown" v-if="get_user.roles.indexOf('A') != -1">
					<router-link data-toggle="tooltip" title="API Key" :to="'/api-key-list'">
						<i class="icon-getAPI"></i> 
					</router-link>
				</li>
				<li class="dropdown">
					<router-link data-toggle="tooltip" title="Coupon List" :to="'/coupon-list'">
						<i class="icon-couponListIcon"></i>
					</router-link>
				</li>
				<li class="dropdown"  v-if="get_user.roles.indexOf('A') != -1 || get_user.roles.indexOf('M') != -1 ">
						<a data-toggle="tooltip" title="FAQ" class="d-flex align-items-center justify-content-between bottom_drop" href="#" @click="knowlegdeBase = !knowlegdeBase">
							<div class="imgeFlow icoLeft mx-auto">
							<img class="inShow" src="../../../../static/prism_admin/images/faq.svg" alt="Icon">
							<img class="hoverShow" src="../../../../static/prism_admin/images/faq-hover.svg" alt="Icon">
							</div>
							<!--  <span>Knowledge Base</span> -->
							<!-- <bookmark-icon size="1.5x" class="custom-class"></bookmark-icon> -->
						</a>
						<ul class="dropdown-menu open-upward" >
							<li>
								<router-link title="category" :to="'/create-category'" :class="($route.path == '/create-category')?'tabActive' :''">
									<!--<feather type="stop-circle"></feather>--><arrow-right-circle-icon size="1.5x" class="custom-class"></arrow-right-circle-icon>  Create Category
								</router-link>
							</li>
							<li>
								<router-link title="Dashboard" :to="'/category-list'" :class="($route.path == '/category-list')?'tabActive' :''">
									<arrow-right-circle-icon size="1.5x" class="custom-class"></arrow-right-circle-icon> Category List
								</router-link>
							</li>
							
							<li >
								<router-link title="articles" :to="'/create-article'" :class="($route.path == '/create-article')?'tabActive' :''">
									<arrow-right-circle-icon size="1.5x" class="custom-class"></arrow-right-circle-icon>  Create Article
								</router-link>
							</li>
							<li >
								<router-link title="Dashboard" :to="'/articles-list'" :class="($route.path == '/articles-list')?'tabActive' :''">
									<arrow-right-circle-icon size="1.5x" class="custom-class"></arrow-right-circle-icon>  Article List
								</router-link>
							</li>
						</ul>
				</li> 
				<li class="dropdown payout"  v-if="get_user.roles.indexOf('BO') != -1 || get_user.roles.indexOf('DP') != -1">
					  <router-link
					  data-toggle="tooltip"
						title="Income Update List"
						:to="'/gross-annual-income'"
					>
						<clipboard-icon size="1.5x" class="custom-class"></clipboard-icon>
					</router-link>
				</li>
				
				<!-- Old Pending Users -->
				<li class="dropdown" v-if="get_user.roles.indexOf('SL') != -1 || get_user.roles.indexOf('BO') != -1 || get_user.roles.indexOf('DP') != -1 || get_user.roles.indexOf('CS') != -1 || get_user.roles.indexOf('SIQ') != -1">
					<router-link data-toggle="tooltip" title="Old Users" to="">
						<user-icon size="1.5x" class="custom-class" style="color: red;"></user-icon>
					</router-link>
					<ul class="dropdown-menu open-upward">
						<li class="dropdown newuser" v-if="get_user.roles.indexOf('SL') != -1 || get_user.roles.indexOf('BO') != -1 || get_user.roles.indexOf('DP') != -1 || get_user.roles.indexOf('CS') != -1 || get_user.roles.indexOf('SIQ') != -1" @click="clear_local_user_filter()">
							<router-link title="New Registerations" :to="'/new-registeration'" >
								<user-plus-icon size="1.5x" class="custom-class"></user-plus-icon>
							</router-link>
						</li>
						<li class="dropdown rmpendinguser" v-if="get_user.roles.indexOf('SL') != -1 || get_user.roles.indexOf('BO') != -1 || get_user.roles.indexOf('DP') != -1 || get_user.roles.indexOf('CS') != -1 || get_user.roles.indexOf('SIQ') != -1" @click="clear_local_user_filter()">
							<router-link title="RM Pending Registerations" :to="'/rm-pending-registeration'">
								<users-icon size="1.5x" class="custom-class"></users-icon>
							</router-link>
						</li>
						<li class="dropdown pendingesign" v-if="get_user.roles.indexOf('SL') != -1 || get_user.roles.indexOf('BO') != -1 || get_user.roles.indexOf('DP') != -1 || get_user.roles.indexOf('CS') != -1 || get_user.roles.indexOf('SIQ') != -1" @click="clear_local_user_filter()">
							<router-link title="Esign Registerations" :to="'/esign-registeration'">
								<file-text-icon size="1.5x" class="custom-class"></file-text-icon>
							</router-link>
						</li>
						<li class="dropdown leadRegisteration"  @click="clear_local_user_filter()" v-if="get_user.roles.indexOf('INITIAL_LEAD') != -1 || get_user.roles.indexOf('SL') != -1 || get_user.roles.indexOf('BO') != -1 || get_user.roles.indexOf('DP') != -1 || get_user.roles.indexOf('CS') != -1 || get_user.roles.indexOf('SIQ') != -1">
							<!-- Handled a Prop to pass max Date and Min Date -->
							<router-link
								title="Lead Registerations"
								:to="{
									path: '/old-lead-registeration',
									query: {
									startDate: '2025-05-23',
									endDate: '2025-06-23',
									maxDate: '2025-06-22'
									}
								}"
							>
							<file-text-icon size="1.5x" class="custom-class"></file-text-icon>
							</router-link>
						</li>
						<li class="dropdown hypervergeBackstageList"  @click="clear_local_user_filter()" v-if="get_user.roles.indexOf('INITIAL_LEAD') != -1 || get_user.roles.indexOf('CS') != -1 || get_user.roles.indexOf('SIQ') != -1 || get_user.roles.indexOf('SL') != -1 || get_user.roles.indexOf('BO') != -1 || get_user.roles.indexOf('DP') != -1">
							<!-- Handled a Prop to pass max Date and Min Date -->
							<router-link
								title="Hyperverge Backstage List"
								:to="{
									path: '/backstage-users',
								}"
							>
							<file-text-icon size="1.5x" class="custom-class"></file-text-icon>
							</router-link>
						</li>
						<li class="dropdown hypervergeUsers"  @click="clear_local_user_filter()" v-if="get_user.roles.indexOf('INITIAL_LEAD') != -1">
							<!-- Handled a Prop to pass max Date and Min Date -->
							<router-link
								title="Hyperverge Users"
								:to="{
									path: '/hyperverge-users',
								}"
							>
							<file-text-icon size="1.5x" class="custom-class"></file-text-icon>
							</router-link>
						</li>

					</ul>
				</li> 

				<!-- <li class="dropdown">
					<router-link data-toggle="tooltip" title="Funds" to="">
						<tag-icon size="1.5x" class="custom-class"></tag-icon>
					</router-link>
					<ul class="dropdown-menu">
						<li class="dropdown payin" >
							<router-link title="payin" :to="'/coupon-list'" >
								<arrow-right-circle-icon size="1.5x" class="custom-class"></arrow-right-circle-icon> Coupon List
							</router-link>
						</li>
						<li class="dropdown payout" >
							<router-link title="payout" :to="'/upload-coupon-list-file'">
								 <upload-icon size="1.5x" class="custom-class"></upload-icon> upload-coupon-list-file
							</router-link>
						</li>
					</ul>
				</li>  -->
				
				<li class="dropdown logOut">
					<a href="#" data-toggle="tooltip"  @click="logout()" title="Logout">
					 	<log-out-icon size="1.5x" class="custom-class"></log-out-icon> 
					</a>
				</li>
				
			</ul>
		</div>
	</section>
</template>
<script> 
	import { Const }  from '@/plugins/prism_admin/provider/candle-history/lib/const.cls'
	import * as types from '@/types'
    import { mapActions } from 'vuex' 
    import { prismMixins } from '@/plugins/prism_admin'
    import { LayoutIcon,BriefcaseIcon,UserIcon,SettingsIcon,UsersIcon,UserPlusIcon,UserCheckIcon,MessageSquareIcon,LogInIcon,FileTextIcon,LogOutIcon,ListIcon,SearchIcon,ArrowRightCircleIcon,ArrowLeftCircleIcon,CreditCardIcon,TrendingDownIcon,FileIcon,BookmarkIcon,LockIcon,TagIcon,UploadIcon,BarChartIcon ,ClipboardIcon } from 'vue-feather-icons'
    export default{
        name: 'PrismApp',
        mixins: [prismMixins],    
        data(){
            return {
            	knowlegdeBase : false,
				isIKF:false
            }
        },
        components: {
           LayoutIcon,
           BookmarkIcon,
           SettingsIcon,
           UsersIcon,
           MessageSquareIcon,
           LogInIcon,
           UserIcon,
           UserPlusIcon,
           UserCheckIcon,FileTextIcon,LogOutIcon,ListIcon,
           BriefcaseIcon ,SearchIcon,ArrowRightCircleIcon,ArrowLeftCircleIcon,CreditCardIcon,TrendingDownIcon,FileIcon,LockIcon,TagIcon,UploadIcon,BarChartIcon,ClipboardIcon
        },
		created(){
			if(this.$store.state.user.route_roles && this.$store.state.user.route_roles=='IKF_USER'){
				this.isIKF = true;
			}
			if(localStorage.getItem("margin_info")){
				var retrievedData = localStorage.getItem("margin_info");
				var recieveData = JSON.parse(retrievedData);
				this.$store.commit(Const.SET_MARGIN_LIST, recieveData);
			}
		},
		methods:{
	        ...mapActions({
	            _runLogout: types.RUN_USER_LOGOUT
	        }),
	        logout(){
	            const r = this.$router
	            this._runLogout({
	                router: r,
	                parameter: this
	            })
	        }
	    },
		mounted(){
			$('.dropdown').click( function() {
				$(this).addClass('active').siblings().removeClass('active');
			});
			$(document).ready(function(){
			  $('[data-toggle="tooltip"]').tooltip();   
			});
			const _that = this
			$(document).on("click", function(event){
				if(!$(event.target).closest('.bottom_drop').length){
					_that.knowlegdeBase = false
				}
		  });
		}
	}
</script>

<style scoped>


@media screen and (max-height : 870px ){
	.open-upward{
		bottom: 0px !important;
		top: auto !important;
	}
}
</style>




// WEBPACK FOOTER //
// src/components/prism_admin/shared/left_navigation.vue